import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  RegistrationTokenFormDataSource
} from 'angular-components/registration-token-form/registration-token-form.data-source';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import {
  DeviceInboxRegistrationTokenControllerGenerateTokenRemoteMethod
} from 'open-api-legacy/remote-methods/device-inbox-registration-token-controller-generate-token.remote-method';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { CopyToClipboardComponent } from '@rxap/components';
import { DateWithTimeAgoPipe } from 'eurogard-pipes';

@Component({
  selector: 'eurogard-registration-token-form',
  standalone: true,
  imports: [
    MatCardModule,
    MatIcon,
    MatButton,
    CopyToClipboardComponent,
    DateWithTimeAgoPipe,
  ],
  templateUrl: './registration-token-form.component.html',
  styleUrl: './registration-token-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RegistrationTokenFormDataSource],
})
export class RegistrationTokenFormComponent {
  private readonly registrationTokenFormDataSource = inject(RegistrationTokenFormDataSource);
  protected readonly registrationTokenFormData = toSignal(this.registrationTokenFormDataSource.connect({ id: 'to-signal-registration-token-form' }));

  private readonly createTokenRemoteMethod = inject(DeviceInboxRegistrationTokenControllerGenerateTokenRemoteMethod);

  private readonly snackBar = inject(MatSnackBar);

  constructor() {
    this.registrationTokenFormDataSource.refresh();
  }

  protected createOrRefreshToken() {
    this.createTokenRemoteMethod.call().then(() => {
      if (this.registrationTokenFormData()) {
        this.snackBar.open($localize`Refresh Token refreshed successfully.`, $localize`Close`, { duration: 3000 });
      } else {
        this.snackBar.open($localize`Refresh Token created successfully.`, $localize`Close`, { duration: 3000 });
      }
      this.registrationTokenFormDataSource.refresh();
    }).catch(() => {
      if (this.registrationTokenFormData()) {
        this.snackBar.open($localize`Refresh Token could not be refreshed.`, $localize`Close`, { duration: 3000 });
      } else {
        this.snackBar.open($localize`Refresh Token could not be created.`, $localize`Close`, { duration: 3000 });
      }
      this.registrationTokenFormDataSource.refresh();
    });
  }
}
